export default __webpack_public_path__ + "1966e96aab96534972a257438ac54075.webp";